import * as React from "react";
import {
  SelectInput,
  TextInput,
  AutocompleteArrayInput,
  NumberInput,
  AutocompleteInput,
  DateTimeInput,
} from "react-admin";
import {
  YesNoEnum
} from "../../common/enum";
import { FileInputAdornment } from "src/components/file-input";

export const CustomField = (props) => {
  const attribute = props.attribute;
  let component = <p>Loading...</p>;

  switch (attribute.type) {
    case "select": {
      const choices = attribute.options.map((option) => ({
        id: option.value,
        name: option.label ?? option.value,
      }));
      component = (
        <AutocompleteInput
          source={props.source}
          label={attribute.name}
          choices={choices}
          optionText="name"
          defaultValue=""
          size="small"
        />
      );
      break;
    }
    case "yes_no": {
      component = (
        <SelectInput 
          source={props.source}
          label={attribute.name}
          choices={YesNoEnum}
          defaultValue="no"
          size="small"
        />
      );
      break;
    }
    case "multiselect": {
      const choices = attribute.options.map((option) => ({
        id: option.value,
        name: option.label ?? option.value,
      }));
      component = (
        <AutocompleteArrayInput
          source={props.source}
          label={attribute.name}
          optionText="name"
          size="small"
          choices={choices}
        />
      );
      break;
    }
    case "file": {
      component = (
        <FileInputAdornment
            source={props.source}
            label={attribute.name}
            fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
            path="admin/media/common"
            multiple={false}
        />
      );
      break;
    }
    case "datetime": {
      component = (
        <DateTimeInput
          source={props.source}
          label={attribute.name}
        />
      );
      break;
    }
    case "number": {
      component = (
        <NumberInput
          source={props.source}
          label={attribute.name}
        />
      );
      break;
    }
    case "textarea": {
      component = (
        <TextInput
          source={props.source}
          label={attribute.name}
          multiline
          rows={4}
        ></TextInput>
      );
      break;
    }
    default: {
      component = (
        <TextInput
          source={props.source}
          label={attribute.name}
        />
      );
      break;
    }
  }

  return component;
};